import { redirect, type ParsedLocation } from "@tanstack/react-router";

import { sdk } from "@/api/sdk";
import { LegalConsentKind, legalConsentsToAsk, type LegalConsentStatus } from "@complete-athlete/enums";

/** The consents this app asks for. A business's own records are not under the health tick. */
export const APP_LEGAL_CONSENTS = [LegalConsentKind.TERMS];

/** The status of the signed-in person, so a navigation does not ask the API every time. */
let known: { userId: string; status: LegalConsentStatus } | null = null;

/** Called when the person changes a consent, so the gate follows without a reload. */
export const rememberLegalConsentStatus = (userId: string, status: LegalConsentStatus) => {
  known = { userId, status };
};

export const legalConsentStatusOf = async (userId: string): Promise<LegalConsentStatus | null> => {
  if (known?.userId === userId) return known.status;
  const { data } = await sdk.legalConsents.$get.send();
  if (data) rememberLegalConsentStatus(userId, data);
  return data;
};

/** Sends anyone who has not agreed to the documents in force to the consent screen. */
export const guardLegalConsents = async ({ userId, location }: { userId: string; location: ParsedLocation }) => {
  const status = await legalConsentStatusOf(userId);
  if (!status) return;
  if (legalConsentsToAsk(status, APP_LEGAL_CONSENTS).length > 0) {
    throw redirect({ to: "/consent", search: location.pathname === "/" ? {} : { redirect: location.href } });
  }
};
